import { Navigate } from "react-router-dom";
import { useToken } from "../components/TokenProvider";

// const PublicRoutes = ({ children, isAdmin }) => {
//     const { accessToken } = useToken(); // Access the token from context
//     const token = accessToken || localStorage.getItem('accessToken');
//     return (!token ? children : <Navigate to={isAdmin ? "/admin/assessments" : "/startPage"} replace />)
    
// };

const PublicRoutes = ({ children, isSuperUser }) => {
    const { accessToken, user } = useToken(); // Ensure user data is available
    const token = accessToken || localStorage.getItem('accessToken');

    return (!token ? children : <Navigate to={isSuperUser ? "/admin/assessments" : "/startPage"} replace />);
};



export default PublicRoutes;